import _ from 'lodash';
import { UtilityFunctions } from '@copilot/common/utils/common';
import { NurturePercentageRingAndDescriptionRow } from './nurturePercentageRingAndDescriptionRow';
import { ProspectingPercentageRingAndDescriptionRow } from './prospectingPercentageRingAndDescriptionRow';
import { isNurtureCampaignStats, isProspectingCampaignStats } from '../../../helpers';
import { CampaignStats } from './types';
import { Col, Row } from 'antd';
import { VerticalDivider } from '@copilot/common/components/verticalDivider';
import styles from '../campaignPerformance.module.less';
import { StatsLoader } from './statsLoader';

type PercentageRingAndDescriptionRowProps = {
    /**
     * The statistics of the campaign
     * Cannot be undefined since loading has finished
     */
    campaignStats?: CampaignStats;
    /**
     * Is the statistics loading
     */
    isLoading: boolean;
    /**
     * Whether or not calculations should be shown
     */
    isShowingCalculations: boolean;
};

/**
 * Loader for a row of percentage rings with descriptions
 */
function PercentageRingAndDescriptionLoader() {
    return (
        <Row justify={'space-evenly'} gutter={[8, 0]}>
            <Col span={7}>
                <StatsLoader />
            </Col>
            <Col>
                <VerticalDivider />
            </Col>
            <Col span={7}>
                <StatsLoader />
            </Col>
            <Col>
                <VerticalDivider />
            </Col>
            <Col span={7}>
                <StatsLoader />
            </Col>
        </Row>
    );
}

/**
 * Internal component to display row percentage rings and descriptions based on campaign
 */
function PercentageRingAndDescriptionRow({
    isLoading,
    campaignStats,
    isShowingCalculations,
}: PercentageRingAndDescriptionRowProps) {
    if (isLoading) return <PercentageRingAndDescriptionLoader />;

    if (_.isUndefined(campaignStats)) {
        throw new Error('Loading finished but campaign stats is still undefined');
    }

    if (_.isUndefined(campaignStats.__typename)) {
        throw new Error('Loading finished but campaign stats typename is still undefined');
    }

    if (isProspectingCampaignStats(campaignStats)) {
        return (
            <div className={styles.loadedContent}>
                <ProspectingPercentageRingAndDescriptionRow
                    campaignStats={campaignStats}
                    isShowingCalculations={isShowingCalculations}
                />
            </div>
        );
    } else if (isNurtureCampaignStats(campaignStats)) {
        return (
            <div className={styles.loadedContent}>
                <NurturePercentageRingAndDescriptionRow
                    campaignStats={campaignStats}
                    isShowingCalculations={isShowingCalculations}
                />
            </div>
        );
    } else {
        UtilityFunctions.assertUnreachable(campaignStats);
        throw TypeError('Campaign stats was not of type prospecting or campaign');
    }
}

export default PercentageRingAndDescriptionRow;
